<template>
  <div class="sc-navbar">
    <div class="sc-navbar-items">
      <button
        class="sc-navbar-button sc-navbar-item"
        v-for="certification in certifications"
        :key="certification.id"
        :class="[{ active: certification.id === Number(route.params.id) }]"
      >
        <div class="sc-row">
          <div class="sc-column sc-icon-container">
            <span class="icon-money-solid"></span>
          </div>
          <div class="sc-column">
            <div class="sc-row sc-title">
              {{ certification?.certifiedAmountDisplay }}
            </div>
            <div class="sc-row">
              <span class="sc-subtext"
                >Sequence #{{ certification?.sequenceNumber }}</span
              >
            </div>
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { useRoute } from "vue-router";
import { CertificationSlimVM } from "@/types/certifications";

const props = defineProps<{ certifications: CertificationSlimVM[] }>();

const route = useRoute();
</script>

<style scoped>
.sc-navbar {
  height: 61px;
  width: fit-content;
}
.sc-navbar-item {
  width: 154px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-radius: 6px 6px 0px 0px;
  background: #f2f3f5;
  height: 61px;
  padding: 10px 11px 11px 11px;
  align-items: center;
  border: none;
  opacity: 1;
}

.sc-navbar-item:not(.active) {
  color: black;
  background-color: white;
  box-shadow: 0 0 0 1px #ccc;
  opacity: 0.5;
}
.sc-navbar-item .sc-icon-container {
  justify-content: center;
}
.sc-navbar-item .sc-title {
  color: #000;
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.sc-navbar-item .sc-subtext {
  color: #000;
  font-family: "Montserrat";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */
  line-height: normal;
}

.sc-navbar-item-column {
  display: flex;
  flex-direction: column;
}

.icon-money-solid:before {
  height: 12px;
}
</style>
<style scoped src="@/assets/css/certifications/certification-form.css"></style>
